<template>
    <div class="box">
        <h4> NETSPACE</h4>
        <h5> {{ netspace.toFixed(2) }} EB</h5>
    </div>
</template>

<script>
import { onMounted, ref } from 'vue';

export default {
    setup() {
        const netspace = ref(0)

        const xch_netspace = () => {
            fetch("https://xchscan.com/api/netspace")
                .then((response) => {
                    return response.json()
                })
                .then((data) => {
                    netspace.value = data.netspace / 2 ** 60;
                })
                .catch(function (error) {
                    console.error(error)
                })
        }

        onMounted(() => {
            xch_netspace()
            setTimeout(() => {
                xch_netspace()
            }, 5000)
        })

        return { netspace }
    },
    mounted() {
    },
};
</script>

<style scoped>
h4,
h5 {
    margin: 0;
}

.box {
    opacity: 0.75;
    color: white;
}
</style>
